import SortIcon from "../../../global/components/SortIcon";
import {
  formatUnixTime,
  formatUTCTime,
} from "../../../global/utils/unixToLocalTime";
import { renderPrice } from "../../../utils/Common";

export const PaymentColumns = (
  setParams,
  params,
  hideBak,
  hideOemDealerForDealerAccount,
) => {
  const modParams = { ...Object.fromEntries([...params?.entries()]) } || {}; //
  const logData = JSON.parse(sessionStorage.getItem("userData"));
  const isSystemUser = [1, 2, 3].includes(logData?.role_value);
  return [
    {
      title: "No",
      dataIndex: "PaymentNo",
      key: "PaymentNo",
      hidden: !isSystemUser,
      sorter: (a, b) => a?.PaymentNo - b?.PaymentNo,
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="PaymentNo"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "PaymentNo",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Payment Time",
      dataIndex: "PaymentTime",
      key: "PaymentTime",
      render: (text) => {
        return <div>{text ? formatUTCTime(text) : ""}</div>;
      },
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="PaymentTime"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "PaymentTime",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "OEM",
      dataIndex: "OemName",
      key: "OemName",
      // Dealers keep their existing hide rule; OEM accounts are newly hidden too.
      hidden:
        hideOemDealerForDealerAccount ||
        [7, 8, 9].includes(logData?.role_value) ||
        [4, 5, 6].includes(logData?.role_value),
      // hidden: [4, 5, 6, 7, 8, 9, 10, 11, 12].includes(logData.role_value),
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="OemNo"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "OemNo",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Dealer",
      dataIndex: "DealerName",
      hidden:
        hideOemDealerForDealerAccount ||
        [7, 8, 9].includes(logData?.role_value),
      key: "DealerName",
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="DealerNo"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "DealerNo",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Amount",
      dataIndex: "Amount",
      key: "Amount",
      render: renderPrice,
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="Amount"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "Amount",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Payment Mode",
      dataIndex: "PaymentMode",
      key: "PaymentMode",
      render: (value) => (value ? String(value) : ""),
    },
    {
      title: "Card",
      dataIndex: "CardLast4",
      key: "CardLast4",
      render: (text, data) => {
        const mode = String(data.PaymentMode ?? "").toLowerCase();
        return mode !== "manual" && text ? (
          <div style={{ marginLeft: "10px" }}>{`**** **** **** ${text}`}</div>
        ) : null;
      },
    },
    {
      title: "",
      fixed: "right",
      width: 0,
      align: "center",
    },
  ];
};

export const PaymentOrderColumns = (setParams, params) => {
  return [
    {
      title: "Order No",
      dataIndex: "OrderNo",
      key: "OrderNo",
      sorter: (a, b) => a?.OrderNo - b?.OrderNo,
      sortIcon: () => (
        <SortIcon
          sortOrder={params.order}
          columnKey="OrderNo"
          sortBy={params.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...prev,
            sort_by: "OrderNo",
            order: prev.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Order Time",
      dataIndex: "OrderTime",
      key: "OrderTime",
      render: (text) => <div>{text ? formatUnixTime(text) : ""}</div>,
      sorter: (a, b) => new Date(a.OrderTime) - new Date(b.OrderTime),
      sortIcon: () => (
        <SortIcon
          sortOrder={params.order}
          columnKey="OrderTime"
          sortBy={params.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...prev,
            sort_by: "OrderTime",
            order: prev.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "MAC",
      dataIndex: "MAC",
      key: "MAC",
      render: (text) => <div>{text ? formatUnixTime(text) : ""}</div>,
      sorter: (a, b) => new Date(a.MAC) - new Date(b.MAC),
      sortIcon: () => (
        <SortIcon
          sortOrder={params.order}
          columnKey="MAC"
          sortBy={params.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...prev,
            sort_by: "MAC",
            order: prev.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Order Type",
      dataIndex: "OrderType",
      key: "OrderType",
      render: (text) => <div>{text ? formatUnixTime(text) : ""}</div>,
      sorter: (a, b) => new Date(a.OrderType) - new Date(b.OrderType),
      sortIcon: () => (
        <SortIcon
          sortOrder={params.order}
          columnKey="OrderType"
          sortBy={params.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...prev,
            sort_by: "OrderTime",
            order: prev.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Order Item",
      dataIndex: "OrderItem",
      key: "OrderItem",
      render: (text) => <div>{text ? formatUnixTime(text) : ""}</div>,
      sorter: (a, b) => new Date(a.OrderItem) - new Date(b.OrderItem),
      sortIcon: () => (
        <SortIcon
          sortOrder={params.order}
          columnKey="OrderItem"
          sortBy={params.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...prev,
            sort_by: "OrderItem",
            order: prev.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Old Code",
      dataIndex: "OldCode",
      key: "OldCode",
      render: (text) => <div>{text ? formatUnixTime(text) : ""}</div>,
      sorter: (a, b) => new Date(a.OldCode) - new Date(b.OldCode),
      sortIcon: () => (
        <SortIcon
          sortOrder={params.order}
          columnKey="OldCode"
          sortBy={params.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...prev,
            sort_by: "OldCode",
            order: prev.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Old Price",
      dataIndex: "OldPrice",
      key: "OldPrice",
      render: (text) => <div>{text ? formatUnixTime(text) : ""}</div>,
      sorter: (a, b) => new Date(a.OldPrice) - new Date(b.OldPrice),
      sortIcon: () => (
        <SortIcon
          sortOrder={params.order}
          columnKey="OldPrice"
          sortBy={params.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...prev,
            sort_by: "OldPrice",
            order: prev.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "New Code",
      dataIndex: "NewCode",
      key: "NewCode",
      render: (text) => <div>{text ? formatUnixTime(text) : ""}</div>,
      sorter: (a, b) => new Date(a.NewCode) - new Date(b.NewCode),
      sortIcon: () => (
        <SortIcon
          sortOrder={params.order}
          columnKey="NewCode"
          sortBy={params.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...prev,
            sort_by: "NewCode",
            order: prev.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "New Price",
      dataIndex: "NewPrice",
      key: "NewPrice",
      render: (text) => <div>{text ? formatUnixTime(text) : ""}</div>,
      sorter: (a, b) => new Date(a.NewPrice) - new Date(b.NewPrice),
      sortIcon: () => (
        <SortIcon
          sortOrder={params.order}
          columnKey="NewPrice"
          sortBy={params.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...prev,
            sort_by: "NewPrice",
            order: prev.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Price",
      dataIndex: "Price",
      key: "Price",
      render: (text) => <div>{text ? formatUnixTime(text) : ""}</div>,
      sorter: (a, b) => new Date(a.Price) - new Date(b.Price),
      sortIcon: () => (
        <SortIcon
          sortOrder={params.order}
          columnKey="Price"
          sortBy={params.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...prev,
            sort_by: "Price",
            order: prev.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    // {
    //   title: "Order Name",
    //   dataIndex: "OrderName",
    //   // hidden: hideBak,
    //   key: "OrderName",
    //   sorter: (a, b) => a?.OrderName?.length - b?.OrderName?.length,
    //   render: (text) => {
    //     return text ? text : "N/A";
    //   },
    //   sortIcon: () => (
    //     <SortIcon
    //       sortOrder={params.order}
    //       columnKey="OrderName"
    //       sortBy={params.sort_by}
    //     />
    //   ),
    //   onHeaderCell: () => ({
    //     onClick: () =>
    //       setParams((prev) => ({
    //         ...prev,
    //         sort_by: "OrderName",
    //         order: prev.order === "desc" ? "asc" : "desc",
    //       })),
    //   }),
    // },

    // {
    //   title: "Amount",
    //   dataIndex: "Amount",
    //   key: "Amount",
    //   render: (text) => {
    //     return `$ ${text}`;
    //   },
    //   sorter: (a, b) => a?.Amount?.length - b?.Amount?.length,
    //   sortIcon: () => (
    //     <SortIcon
    //       sortOrder={params.order}
    //       columnKey="Amount"
    //       sortBy={params.sort_by}
    //     />
    //   ),
    //   onHeaderCell: () => ({
    //     onClick: () =>
    //       setParams((prev) => ({
    //         ...prev,
    //         sort_by: "Amount",
    //         order: prev.order === "desc" ? "asc" : "desc",
    //       })),
    //   }),
    // },
  ];
};

export const OrderItemColumns = (setParams, params) => {
  return [
    {
      title: "Invoice No",
      dataIndex: "ItemNo",
      key: "ItemNo",
      sorter: (a, b) => a?.ItemNo - b?.ItemNo,
      sortIcon: () => (
        <SortIcon
          sortOrder={params.order}
          columnKey="ItemNo"
          sortBy={params.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...prev,
            sort_by: "ItemNo",
            order: prev.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    // {
    //   title: "Customer",
    //   dataIndex: "CustomerName",
    //   // hidden: hideBak,
    //   key: "CustomerName",
    //   sorter: (a, b) => a?.CustomerName?.length - b?.CustomerName?.length,
    //   render: (text) => {
    //     return text ? text : "N/A";
    //   },
    //   sortIcon: () => (
    //     <SortIcon
    //       sortOrder={params.order}
    //       columnKey="CustomerName"
    //       sortBy={params.sort_by}
    //     />
    //   ),
    //   onHeaderCell: () => ({
    //     onClick: () =>
    //       setParams((prev) => ({
    //         ...prev,
    //         sort_by: "CustomerName",
    //         order: prev.order === "desc" ? "asc" : "desc",
    //       })),
    //   }),
    // },
    {
      title: "Order Item",
      dataIndex: "CustomerName",
      // hidden: hideBak,
      key: "CustomerName",
      sorter: (a, b) => a?.CustomerName?.length - b?.CustomerName?.length,
      render: (text) => {
        return text ? text : "N/A";
      },
      sortIcon: () => (
        <SortIcon
          sortOrder={params.order}
          columnKey="CustomerName"
          sortBy={params.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...prev,
            sort_by: "CustomerName",
            order: prev.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    // {
    //   title: "License",
    //   dataIndex: "LicenseName",
    //   key: "LicenseName",
    //   sorter: (a, b) => a?.LicenseName?.length - b?.LicenseName?.length,
    //   sortIcon: () => (
    //     <SortIcon
    //       sortOrder={params.order}
    //       columnKey="LicenseName"
    //       sortBy={params.sort_by}
    //     />
    //   ),
    //   onHeaderCell: () => ({
    //     onClick: () =>
    //       setParams((prev) => ({
    //         ...prev,
    //         sort_by: "LicenseName",
    //         order: prev.order === "desc" ? "asc" : "desc",
    //       })),
    //   }),
    // },
    {
      title: "Price",
      dataIndex: "Price",
      key: "Price",
      render: renderPrice,
      sorter: (a, b) => a?.Price?.length - b?.Price?.length,
      sortIcon: () => (
        <SortIcon
          sortOrder={params.order}
          columnKey="Price"
          sortBy={params.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...prev,
            sort_by: "Price",
            order: prev.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Paid",
      dataIndex: "CustomerName",
      // hidden: hideBak,
      key: "CustomerName",
      sorter: (a, b) => a?.CustomerName?.length - b?.CustomerName?.length,
      render: (text) => {
        return text ? text : "N/A";
      },
      sortIcon: () => (
        <SortIcon
          sortOrder={params.order}
          columnKey="CustomerName"
          sortBy={params.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...prev,
            sort_by: "CustomerName",
            order: prev.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "",
      fixed: "right",
      width: 0,
      align: "center",
    },
  ];
};
